import { IPosition } from '@nkr/models/index';

export interface ISwapManagementPosition extends IPosition {
    index: number,
    isNotCurrent: boolean,
    highlightRow: boolean
    highlightRecipient: boolean
    highlightDonor: boolean
}